import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import noop from "../../../../../core/modules/common/tools/noop";

const CarrierResdit7421PerformanceReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id,
        label: 'Operator',
      },
      {
        value: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
        label: 'Location',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
      {
        value: ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_802.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default CarrierResdit7421PerformanceReport;

CarrierResdit7421PerformanceReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  onSortedChange: noop,
  onFilteredChange: noop,
};
